import isEmpty from 'is-empty';
import {
  ROBO_ADVISORY_SUCCESS,
  ROBO_ADVISORY_ERROR,
  ROBO_ADVISORY_LOADING,
  ROBO_ADVISORY_ERROR_DELETE
} from '../../actions/types';

const initialState = {
  success: false,
  data: {},
  error: '',
  loading: false
};

const postRoboAdvisory = (state = initialState, action) => {
  switch (action.type) {
    case ROBO_ADVISORY_SUCCESS:
      return {
        ...state,
        success: !isEmpty(action.advisory),
        data: action.advisory,
        loading: false,
      };
    case ROBO_ADVISORY_ERROR:
      return {
        ...state,
        success: false,
        error: action.error,
        loading: false
      };
    case ROBO_ADVISORY_ERROR_DELETE:
      return {
        error: ''
      };
    case ROBO_ADVISORY_LOADING:
      return {
        ...state,
        loading: true
      };
    default: return state;
  }
};

export default postRoboAdvisory;
